import { Button, Col, Divider, Form, Input, message, Modal, Row, Select, Spin, Tooltip } from 'antd';
import FormItem from 'antd/lib/form/FormItem';
import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { IModuleInfo, ProgressParamType } from '../../../redux/progress/module/moduleInterface';
import { IState } from '../../../redux/store';
import RealTimeTitleBlock from './RealTimeTitleBlock';
import dateFormat from '../../../utils/dateFormat';
import RealTimeFileItem from './RealTimeFileItem';
import RealTimeDataPicker from './RealTimeDataPicker';
import httpRequest from '../../../utils/HttpRequest';
import { useParams } from 'react-router';
import { TECHNIC_PREFIX } from '../../../config/technicPrefix';
import { urls } from '../../../config/url';
import { setActiveLine, updateLines } from '../../../redux/progress/line/lineAction';
import useUpdateLine from '../header/useLine';
import { ILines } from '../../../redux/progress/line/lineReducer';
import { IModuleParams } from '../../../redux/progress/param/paramReducer';
import { updateParam } from '../../../redux/progress/param/paramAction';
import store from "../../../redux/store";
import { bool } from 'prop-types';
import { el } from 'date-fns/locale';
const { Option } = Select;

export interface RealTimeParamsPropies {
    module?: IModuleInfo;
    activeProject: string;
    username: string;
    setActiveLine: (name: string) => void;
    updateLines: (lines: ILines) => void,
    params: IModuleParams;
    updateParam: (params: IModuleParams) => void;
    surveyData: { line: string | number, point: string | number, devno: string | number } | null | undefined,
    lineName: string,
    job2s: any,
    disableTable: (params: boolean) => void;
    tableClick: boolean,
    tableEdit: (params: boolean) => void;
}

interface FieldData {
    name: string | number | (string | number)[];
    value?: any;
    touched?: boolean;
    validating?: boolean;
    errors?: string[];
}

function params2FieldData(params: IModuleParams): FieldData[] {
    const fieldData: FieldData[] = [];
    for (const key in params) {
        if (params.hasOwnProperty(key)) {
            const param = params[key];
            fieldData.push({
                name: key,
                value: param,
            });
        }
    }
    return fieldData;
}

function fieldData2Params(fieldData: FieldData[]): IModuleParams {
    const params: IModuleParams = {};
    fieldData.forEach(field => {
        params[(field.name as string[])[0]] = field.value;
    }
    );
    return params;
}

function RealTimeParams(props: RealTimeParamsPropies) {
    // 表单信息
    // const [fields, setFields] = useState<FieldData[]>([]);
    // 模块类别
    let { spec, tech } = useParams<{ spec: string, tech: string }>();

    const [submitBtn, setSubmitBtn] = useState<boolean>(false) // 提交
    const [stopBtn, setStopBtn] = useState<boolean>(false) // 停止
    const [resetBtn, setResetBtn] = useState<boolean>(false) // 重置
    const [paramDis, setParamsDis] = useState<boolean>(false)
    const [resetModel, setResetModel] = useState<boolean>(false)
    // 更新测线
    const updateLines = useUpdateLine(props.username, props.activeProject, props.updateLines, tech);
    const [txt, setTxt] = useState<string>('')
    const [resetData, setResetData] = useState<boolean>(false)
    useEffect(() => {

        let data = JSON.stringify(props.job2s.job2s)
        if (data == '{}') {
            setSubmitBtn(false)
            setStopBtn(true)
            setResetBtn(true)
        } else {
            let status
            if (props.job2s.job2s.rtpspsfi) {
                status = props.job2s.job2s.rtpspsfi.status
            } else if (props.job2s.job2s.rtsw) {
                status = props.job2s.job2s.rtsw.status
            } else if (props.job2s.job2s.rtpl) {
                status = props.job2s.job2s.rtpl.status
            }

            if (status === 1 || status === 2 || status === 3) {

                setSubmitBtn(true)
                setStopBtn(false)
                setResetBtn(true)
                setParamsDis(true)
            } else {

                if (status === 0) {
                    if (props.job2s.job2s.rtpspsfi) {
                        if (props.job2s.job2s.rtpspsfi.log[0].value === '等待实时计算作业执行......') {
                            setSubmitBtn(true)
                            setStopBtn(false)
                            setResetBtn(true)
                            setParamsDis(true)
                        } else {
                            setSubmitBtn(false)
                            setStopBtn(true)
                            setResetBtn(true)
                            setParamsDis(false)
                        }
                    } else if (props.job2s.job2s.rtsw) {
                        if (props.job2s.job2s.rtsw.log[0].value === '等待实时计算作业执行......') {
                            setSubmitBtn(true)
                            setStopBtn(false)
                            setResetBtn(true)
                            setParamsDis(true)
                        } else {
                            setSubmitBtn(false)
                            setStopBtn(true)
                            setResetBtn(true)
                            setParamsDis(false)
                        }
                    } else if (props.job2s.job2s.rtpl) {
                        if (props.job2s.job2s.rtpl.log[0].value === '等待实时计算作业执行......') {
                            setSubmitBtn(true)
                            setStopBtn(false)
                            setResetBtn(true)
                            setParamsDis(true)
                        } else {
                            setSubmitBtn(false)
                            setStopBtn(true)
                            setResetBtn(true)
                            setParamsDis(false)
                        }
                    }

                } else {
                    setSubmitBtn(false)
                    setStopBtn(true)
                    setResetBtn(true)
                    setParamsDis(false)
                }

            }
        }

    }, [props.job2s])
    useEffect(() => {
        if (props.disableTable) {
            props.disableTable(paramDis)
        }
    }, [paramDis])
    // 默认信息
    const getDefault = useCallback(() => {
        if (props.module === undefined) return {};
        const params = props.module.PRO_MODULE_PARAMS;
        const defaultVal: { [key: string]: any } = {
            job_name: `${props.module.PRO_MODULE_NAME}-${dateFormat("YYYYmmdd:HH:MM:SS", new Date())}`
        };

        params.forEach(param => {
            switch (param.PARAMTYPE) {
                case ProgressParamType.DATE:
                    defaultVal[param.PARAMNAME] = param.PARAMDEFAULTVALUE === '' ? new Date().valueOf() : param.PARAMDEFAULTVALUE;
                    break;
                default:
                    defaultVal[param.PARAMNAME] = param.PARAMDEFAULTVALUE;
                    break;
            }
        })
        return { ...defaultVal, ...props.params };

    }, [props.module, props.params]);

    // 如果获取不到列表显示加载中
    if (!props.module) {
        return <Spin />
    }

    // 参数信息
    const params = props.module.PRO_MODULE_PARAMS;

    //生成表单
    const items = params.map(param => {
        let itemInput = <></>

        if (param.HIDE === 'YES') return <></>
        switch (param.PARAMTYPE) {
            case ProgressParamType.FILE:
                itemInput = <RealTimeFileItem param={param} />
                break;
            case ProgressParamType.ENUM:
                const enumValueList = (param.PARAMDEVALUERANGE as string).split(";");
                itemInput = <Select disabled={paramDis}>
                    {enumValueList.map(val => <Option key={val} value={val} >{val}</Option>)}
                </Select>
                break;
            case ProgressParamType.DATE:
                itemInput = <RealTimeDataPicker disabled={paramDis} typeName={param.PARAMALIASNAME} />
                break;
            case ProgressParamType.DATE:
                itemInput = <RealTimeDataPicker disabled={paramDis} typeName={param.PARAMALIASNAME} />
                break;
            default:
                itemInput =
                
                    <Input/>
                   
                break;
        }

        return <Tooltip title={String(param.PARAMDESC)} placement="right" overlayStyle={{ maxWidth: 350, fontSize: 16 }}>
            <FormItem
                labelCol={{ span: 10 }}
                wrapperCol={{ span: 14 }}
                label={param.PARAMALIASNAME}
                name={param.PARAMNAME}
                style={{
                    fontWeight: 'bolder',
                    marginBottom: '0.2vh',
                }}
                key={param.PARAMNAME}

                rules={[
                    { required: param.PARAMMAX && param.PARAMMIN, message: '请输入内容' },
                    {
                        validator(_, value) {
                            let max = param.PARAMMAX
                            let min = param.PARAMMIN
                            if (param.PARAMMAX && param.PARAMMIN) {
                                if (value < max && value > min) {
                                    return Promise.resolve();
                                } else {
                                    return Promise.reject(`取值范围` + min + `-` + max);
                                }
                            } else {
                                return Promise.resolve();
                            }

                        },
                    },
                ]}


            >
                {itemInput}
            </FormItem>
        </Tooltip>
    })


    return <RealTimeTitleBlock title={'模块参数'}>
        <Form
            name={'Params List'}
            initialValues={getDefault()}
            labelAlign={'right'}
            onFinish={async (values) => {
                try {
                    await new Promise<void>((resolve, reject) => {
                        Modal.confirm({
                            title: '确认提交',
                            content: `确认提交模块${props.module?.PRO_MODULE_ALIASNAME}吗？`,
                            onOk: () => resolve(),
                            onCancel: () => reject(),
                        })
                    })
                } catch {
                    return;
                }
                if (props.tableClick === false) {
                    message.error('请先点击表格确认按钮，确认表格数据')
                    return
                }
                var date = new Date();
                // 获取当前月份
                var nowMonth: string | number = date.getMonth() + 1;
                // 获取当前是几号
                var strDate: string | number = date.getDate();
                if (nowMonth >= 1 && nowMonth <= 9) {
                    nowMonth = "0" + nowMonth;
                }
                // 对月份进行处理，1-9号在前面添加一个“0”
                if (strDate >= 0 && strDate <= 9) {
                    strDate = "0" + strDate;
                }
                let str = 'STARTDATE,STARTTIME,ENDDATE,ENDTIME,LINE,POINT,EUINO,XCOR,YCOR,ELEV' + "\r\n"
                let time = String(date.getFullYear()) + nowMonth + strDate
                let mm = '10:00:00'
                let endm = '12:00:00'
                let arr = []
                if ((props.surveyData as any)[0].hasOwnProperty('STARTDATE')) {
                    values.survey_path = props.surveyData
                } else {
                    for (let index = 0; index < (props.surveyData as any).length; index++) {
                        const element = (props.surveyData as any)[index];
                        arr.push({ STARTDATE: time, STARTTIME: mm, ENDDATE: time, ENDTIME: endm, LINE: element.LINE, POINT: element.POINT, EUINO: element.EUINO, XCOR: element.XCOR, YCOR: element.YCOR, ELEV: element.ELEV })
                    }
                    values.survey_path = props.surveyData
                }



                if (resetData === true) {
                    values.llaa = '-999'
                }
                // 校验参数
                for (const param of params) {
                    if (values[param.PARAMNAME] === undefined || values[param.PARAMNAME] === '') {
                        Modal.error({
                            title: '参数错误',
                            content: `参数'${param.PARAMALIASNAME}'不能为空`,
                        });
                        return;
                    }
                }
                if (props.lineName == '') {
                    let lineData = store.getState().progress.line.lines

                    for (let i in lineData) {
                        if (lineData[i] == values.proj_name) {
                            message.error('测线已经存在，不能重复建立')
                            return
                        }
                    }
                }

                if (txt != '') {
                    message.error(txt)
                    return
                }



                // // 提交参数
                httpRequest(urls.submitJob, {
                    USER_NAME: props.username,
                    PROJECTNAME: props.activeProject,
                    PRO_MODULE_CLASS: spec,
                    PRO_MODULE_CATEGORY: tech,
                    PRO_MODULE_NAME: props.module!.PRO_MODULE_NAME,
                    JOB_NAME: values.job_name,
                    PARAMS: values,
                    PROCESSMODULE_EXECORDER: props.module!.PRO_MODULE_EXECORDER,
                    TECHNIC_PREFIX: (TECHNIC_PREFIX as any)[tech],
                    PRO_MODULE_TECHTYPE: props.module!.PRO_MODULE_TECHTYPE,
                    PRO_MODULE_LANGUAGE: props.module!.PRO_MODULE_LANGUAGE,
                    PRO_MODULE_MEDIA: props.module!.PRO_MODULE_MEDIA,
                    FLOWTYPE: "realtime",
                }).then(res => {
                    if (res.data.errno !== 0) {
                        Modal.error({
                            title: '提交失败',
                            content: res.data.errmsg,
                        });
                    } else {
                        message.success('提交成功');
                        // 更新测线
                        if (values.proj_name && values.proj_name !== props.activeProject) {
                            updateLines().then(() => props.setActiveLine(values.proj_name));
                        }
                        setStopBtn(false)
                        setResetBtn(true)
                        setSubmitBtn(true)
                        setParamsDis(true)
                        setResetData(false)
                        if (props.tableEdit) {
                            props.tableEdit(false)
                        }
                        // if (resetBtn) { // resetBtn为true 这时为开始按钮点击
                        //     setStopBtn(false)
                        //     setResetBtn(false)
                        //     setSubmitBtn(true)
                        // } else {
                        //     setStopBtn(false)
                        //     setResetBtn(false)
                        //     setSubmitBtn(true)
                        // }
                    }
                }).catch(err => {
                    Modal.error({
                        title: '提交失败',
                        content: err.message,
                    });
                })


            }}
            fields={params2FieldData(props.params)}
            onFieldsChange={(_, allFields) => {
                // setFields(allFields);
                updateParam(fieldData2Params(allFields));
            }}
        >

            {items}

            <Divider />
            <Row gutter={[12, 16]}>
                <Col>
                    <Button type="primary" htmlType="submit" disabled={submitBtn} >
                        提交
                    </Button>
                </Col>

                <Col>
                    <Button type="primary" disabled={stopBtn} onClick={async () => {
                        try {
                            await new Promise<void>((resolve, reject) => {
                                Modal.confirm({
                                    title: '确认停止',
                                    content: `确认停止模块${props.module?.PRO_MODULE_ALIASNAME}吗？`,
                                    onOk: () => resolve(),
                                    onCancel: () => reject(),
                                })
                            })
                        } catch {
                            return;
                        }

                        httpRequest(urls.stopjob, {
                            USER_NAME: props.username,
                            PROJECTNAME: props.activeProject,
                            PRO_MODULE_CLASS: spec,
                            PRO_MODULE_CATEGORY: tech,
                            proj_name: props.params.proj_name,
                        }).then(res => {
                            if (res.data.errno !== 0) {
                                Modal.error({
                                    title: '停止失败',
                                    content: res.data.errmsg,
                                });
                            } else {
                                message.success('停止成功');
                                setSubmitBtn(true)
                                setStopBtn(true)
                                setResetBtn(false)
                                setParamsDis(true)
                            }
                        }).catch(err => {
                            Modal.error({
                                title: '停止失败',
                                content: err.message,
                            });
                        });
                    }}>
                        停止
                    </Button>
                </Col>
                <Col>
                    <Button type="primary" disabled={resetBtn} onClick={() => {
                        setResetModel(true)

                    }}>重置</Button>
                </Col>

            </Row>
            <Modal title="Basic Modal" visible={resetModel} onOk={() => {
                setSubmitBtn(false)
                setStopBtn(true)
                setResetBtn(true)
                setParamsDis(false)
                setResetModel(false)
                setResetData(true)
            }} onCancel={() => {

                setResetModel(false)
            }}>
                <p>是否将清除原工区缓存中的所有计算数据？</p>

            </Modal>
        </Form>
    </RealTimeTitleBlock>
}

const mapStateToProps = (state: IState) => {
    const modules = state.progress.modules.modules;
    const activeIndex = state.progress.modules.activeIndex;
    return {
        module: modules[activeIndex],
        activeProject: state.project.activeName,
        username: state.user.userName,
        params: state.progress.params,
        lineName: state.progress.line.activeName,
        job2s: state.progress,
    };
};

export default connect(
    mapStateToProps,
    { setActiveLine, updateLines, updateParam }
)(RealTimeParams);